import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Reloads the current page in place every `interval` ms while the element is
// on the page — used to pick up a payment confirmation without a manual refresh.
export default class extends Controller {
  static values = { interval: { type: Number, default: 10000 } }

  connect() {
    this.timer = setInterval(() => Turbo.visit(window.location.href, { action: "replace" }), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }
}
